const VUE_APP_NODE = process.env.VUE_APP_NODE;

console.log(VUE_APP_NODE)
export const redirectUrl = VUE_APP_NODE === 'test' ? '/admin/index.html' : '/';
console.log(redirectUrl)

export const goodFileRegion = 'ap-chongqing';

export const goodFileBucket = 'ddbes-repository-1304188286';

export const fileFloder = 'DDBES_SHOP';

export const cdnUrl = 'https://cdn.ddbes.com';

